import React, { useEffect, useState, useRef } from 'react';

export const AppContext = React.createContext({});
AppContext.name = 'AppContext';

export const AppProvider = ({ children, parameters }) => {
   return <AppContext.Provider value={ parameters }>{children}</AppContext.Provider>;
};